import { render, staticRenderFns } from "./deduplicationipcontrol.vue?vue&type=template&id=29f66770&"
import script from "./deduplicationipcontrol.vue?vue&type=script&lang=js&"
export * from "./deduplicationipcontrol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports